import React, { useState } from "react";
import CountUp from "react-countup";
import OwlCarousel from "react-owl-carousel";
import { Link } from 'react-router-dom';


import "./mycss.css";

const formatNumber = (number) => {
  if (number === 100000) {
    return "100k";
  } else if (number >= 1000 && number < 1000000) {
    return `${(number / 1000).toFixed(1)}k`;
  } else {
    return number;
  }
};

const Home = () => {
  const [activeTab, setActiveTab] = useState('#tab-1');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const options = {
    items: 4,
    loop: true,
    margin: 90,
    nav: true,
    dots: true,
    autoplay: true,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
        nav: true,
        dots: true
      },
      768: {
        items: 2,
        nav: true,
        dots: true
      },
      992: {
        items: 4,
        nav: true,
        dots: true
      }
    }
  };


  return (
    <>
      <section className="banner-section">
        <div className="line-box">
          <div className="line-1"></div>
          <div className="line-2"></div>
        </div>
        <OwlCarousel
          className="banner-carousel owl-theme owl-carousel"
          items={1}
          loop
          autoplay
          autoplayHoverPause
          nav
          dots
        >
          <div className="slide-item">
            <div
              className="image-layer"
              style={{ backgroundImage: "url(assets/img/bg-2.png)" }}
            ></div>
            <div className="auto-container">
              <div className="content-box">
                <span className="special-text animation_text_word"></span>
                <h2>
                  <span>Your Bearing Experts,</span> <br />
                  <span>Always Ready</span>
                </h2>
                <p>
                  Offering technical expertise and extensive inventory to meet
                  your specific bearing needs promptly.
                </p>
                <div className="btn-box">
                  <Link 
                    to ="/Our_Category"
                    className="theme-btn btn-one"
                  >
                    <span>Our Products</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="slide-item">
            <div
              className="image-layer"
              style={{ backgroundImage: "url(assets/img/bg-3.png)" }}
            ></div>
            <div className="auto-container">
              <div className="content-box">
                <span className="special-text animation_text_word"></span>
                <h2>
                  <span>Reliable, Responsive,</span> <br />
                  <span>Resourceful</span>
                </h2>
                <p>
                  Strategically located warehouses for efficient delivery,
                  offering solutions for every application.
                </p>
                <div className="btn-box">
                  <Link 
                    to ="/Contact_Us"
                    className="theme-btn btn-one"
                  >
                    <span>Contact Us</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="slide-item">
            <div
              className="image-layer"
              style={{ backgroundImage: "url(assets/images/banner/bg-1.png)" }}
            ></div>
            <div className="auto-container">
              <div className="content-box">
                <span className="special-text animation_text_word">SNK</span>
                <h2>
                  <span>Precision Partners</span> <br />
                  <span>Since 1983</span>
                </h2>
                <p>
                  Delivering precision bearings for over three decades, catering
                  to diverse industries with quality solutions.
                </p>
                <div className="btn-box">
                  <Link 
                    to ="About_Us"
                    className="theme-btn btn-one"
                  >
                    <span>About Us</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </OwlCarousel>
        <div className="text-box">
          <div className="text-1">
            <h3>SNKB Bearings</h3>
          </div>
        </div>
      </section>

      <section className="about-section">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-lg-6 col-md-12 col-sm-12 image-column">
              <div className="image-box">
                <figure className="image">
                  <img src="assets/img/ABOUT-US.png" alt="About Us" />
                </figure>
                <div className="text">
                  <h5>40+ Years Experienced</h5>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 content-column">
              <div className="content-box">
                <div className="sec-title">
                  <span className="sub-title">About Us</span>
                  <h2 style={{ fontSize: "35px", lineHeight: "49px" }}>
                    High Precision High Quality
                  </h2>
                  <h3>We believe in precision</h3>
                </div>
                <div className="text">
                  <p>
                    Since 1983, bearings have been our sole focus at SNKB
                    Bearing Store. With one of Mumbai's largest inventories, we
                    offer over 2000 different items available for shipment, with
                    new arrivals daily. Our dedicated team takes pride in
                    understanding each customer's unique requirements, providing
                    expert technical guidance to identify the best solutions for
                    any application. Strategically located and stocked
                    warehouses ensure prompt delivery, backed by competitive
                    pricing. We offer special price quotations for volume orders
                    and hard-to-find items, making us a preferred source for
                    precision bearings. SNKB serves industries ranging from
                    precision machine tools to national defense, ensuring
                    reliable supply for critical applications.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="funfact-section">
        <span className="big-text">Numbers</span>
        <div className="outer-container">
          <div className="row clearfix" style={{ textAlign: "center" }}>
            <div className="col-lg-4 col-md-6 col-sm-12 funfact-block">
              <div className="funfact-block-one">
                <div className="inner-box">
                  <div className="icon-box">
                    <img
                      src="assets/img/branch.png"
                      style={{
                        paddingBottom: "10px",
                        height: "50px",
                        width: "50px",
                      }}
                      alt="Branch Icon"
                    />
                  </div>
                  <div className="count-outer count-box counted">
                    <CountUp start={0} end={45} duration={2} separator="," />
                  </div>
                  <div className="text">
                    <h3>Branch</h3>
                    <p>Branch Across The India</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 funfact-block">
              <div className="funfact-block-one">
                <div className="inner-box">
                  <div className="icon-box">
                    <img
                      src="assets/img/sales-marketing.png"
                      style={{
                        paddingBottom: "10px",
                        height: "50px",
                        width: "50px",
                      }}
                      alt="Sales & Marketing Icon"
                    />
                  </div>
                  <div className="count-outer count-box counted">
                    <CountUp
                      start={0}
                      end={100}
                      suffix="k"
                      duration={3}
                      separator=","
                    />
                  </div>

                  <div className="text">
                    <h3>Product Sale</h3>
                    <p>100k Products Sold Quality Assured</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 funfact-block">
              <div className="funfact-block-one">
                <div className="inner-box">
                  <div className="icon-box">
                    <img
                      src="assets/img/people.png"
                      style={{
                        paddingBottom: "10px",
                        height: "50px",
                        width: "50px",
                      }}
                      alt="People Icon"
                    />
                  </div>
                  <div className="count-outer count-box counted">
                    <CountUp
                      start={0}
                      end={3}
                      suffix="k"
                      duration={2.5}
                      separator=","
                    />
                  </div>
                  <div className="text">
                    <h3>Satisfied Customers</h3>
                    <p>Top Engineers around the World</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-section sec-pad bg-color-1">
        <div className="line-box">
          <div className="line line-1"></div>
          <div className="line line-2"></div>
          <div className="line line-3"></div>
          <div className="line line-4"></div>
        </div>
        <div className="auto-container">
          <div className="sec-title centred">
            <span className="sub-title">Product Segments</span>
            <h2>Our Product Segments</h2>
          </div>
          <div className="row clearfix">
            <div className="col-lg-4 col-md-6 col-sm-12 service-block">
              <div className="service-block-one">
                <div className="inner-box">
                  <div className="image-box">
                    <figure className="image">
                      <img
                        src="assets/img/Industrial-Bearings.png"
                        style={{
                          backgroundSize: "cover",
                          width: "280px",
                          height: "280px",
                        }}
                        alt=""
                      />
                    </figure>
                    <div
                      className="shape"
                      style={{
                        backgroundImage: "url(assets/images/shape/shape-2.png)",
                      }}
                    ></div>
                  </div>
                  <div className="lower-content">
                    <span className="big-text">IB</span>
                    <h3>
                      <Link >Industrial Bearings</Link>
                    </h3>
                    <p>
                      SNKB supplies bearings for various industrial
                      applications, including machinery used in manufacturing,
                      mining, and construction sectors, ensuring efficient
                      operation and reliability in demanding industrial
                      environments.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 service-block">
              <div className="service-block-one">
                <div className="inner-box">
                  <div className="image-box">
                    <figure className="image">
                      <img
                        src="assets/img/Automotive-bearings.png"
                        style={{
                          backgroundSize: "cover",
                          width: "280px",
                          height: "280px",
                        }}
                        alt=""
                      />
                    </figure>
                    <div
                      className="shape"
                      style={{
                        backgroundImage: "url(assets/images/shape/shape-2.png)",
                      }}
                    ></div>
                  </div>
                  <div className="lower-content">
                    <span className="big-text">AB</span>
                    <h3>
                      <Link >Automotive bearings</Link>
                    </h3>
                    <p>
                      SNKB offers a wide range of bearings suitable for
                      automotive applications, including wheel bearings,
                      transmission bearings, and engine bearings, meeting the
                      demanding requirements of the automotive industry.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 service-block">
              <div className="service-block-one">
                <div className="inner-box">
                  <div className="image-box">
                    <figure className="image">
                      <img
                        src="assets/img/Infrastructure.png"
                        style={{
                          backgroundSize: "cover",
                          width: "280px",
                          height: "280px",
                        }}
                        alt=""
                      />
                    </figure>
                    <div
                      className="shape"
                      style={{
                        backgroundImage: "url(assets/images/shape/shape-2.png)",
                      }}
                    ></div>
                  </div>
                  <div className="lower-content">
                    <span className="big-text">AB</span>
                    <h3>
                      <Link >Aerospace Bearings</Link>
                    </h3>
                    <p>
                      Aerospace Bearings: SNKB offers bearings suitable for
                      aerospace applications, meeting the stringent requirements
                      of the aerospace industry for precision, reliability, and
                      performance in extreme operating conditions.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="chooseus-section">
        <div
          className="pattern-layer"
          style={{ backgroundImage: "url(assets/images/shape/shape-4.png)" }}
        ></div>
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-xl-6 col-lg-12 col-md-12 title-column">
              <div className="sec-title">
                <span className="sub-title">Why Choose Us</span>
                <h2>
                  Your Bearings Expert Since 1983 - Trust SNKB for Quality,
                  Value, and Service
                </h2>
                <p>
                  Since 1983, SNKB has been your trusted bearings expert,
                  delivering unparalleled quality, value, and service. Count on
                  us for precision solutions that stand the test of time
                </p>
                <Link  to ="#" className="theme-btn btn-two">
                  <span>More Details</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="right-column">
          <div className="scroll-text">
            <ul className="text-list clearfix">
              <li>Your Bearings Expert Since 1983 </li>
              <li>Trust SNKB for Quality, Value, and Services</li>
            </ul>
          </div>
          <div className="content-box">
            <div className="single-item">
              <div className="static-content">
                <span className="count-text">01</span>
                <div className="text">
                  <h3>100% Genuine supply</h3>
                  <p>
                    SNKB Bearing Store guarantees 100% genuine supply, ensuring
                    customers receive authentic products of the highest quality
                    and reliability.
                  </p>
                </div>
              </div>
              <div className="overlay-content">
                <div className="icon-box">
                  <img
                    src="assets/img/Genuine-supply.png"
                    style={{
                      paddingBottom: "5px",
                      width: "55px",
                      height: "55px",
                    }}
                    alt=""
                  />
                </div>
                <div className="text">
                  <h3>100% Genuine supply</h3>
                  <p>
                    SNKB Bearing Store guarantees 100% genuine supply, ensuring
                    customers receive authentic products of the highest quality
                    and reliability.
                  </p>
                </div>
              </div>
            </div>
            <div className="single-item">
              <div className="static-content">
                <span className="count-text">02</span>
                <div className="text">
                  <h3>40 Years of expectations</h3>
                  <p>
                    Exceeding expectations for four decades, delivering quality
                    bearings worldwide.
                  </p>
                </div>
              </div>
              <div className="overlay-content">
                <div className="icon-box">
                  <img
                    src="assets/img/expectations.png"
                    style={{
                      paddingBottom: "5px",
                      width: "55px",
                      height: "55px",
                    }}
                    alt=""
                  />
                </div>
                <div className="text">
                  <h3>40 Years of expectations</h3>
                  <p>
                    Exceeding expectations for four decades, delivering quality
                    bearings worldwide.
                  </p>
                </div>
              </div>
            </div>
            <div className="single-item">
              <div className="static-content">
                <span className="count-text">03</span>
                <div className="text">
                  <h3>24X7 Services</h3>
                  <p>
                    SNKB Bearing Store provides 24/7 services, ensuring prompt
                    assistance and support to customers around the clock,
                    enhancing reliability and customer satisfaction.
                  </p>
                </div>
              </div>
              <div className="overlay-content">
                <div className="icon-box">
                  <img
                    src="assets/img/24-7.png"
                    style={{
                      paddingBottom: "5px",
                      width: "55px",
                      height: "55px",
                    }}
                    alt=""
                  />
                </div>
                <div className="text">
                  <h3>24X7 Services</h3>
                  <p>
                    SNKB Bearing Store provides 24/7 services, ensuring prompt
                    assistance and support to customers around the clock,
                    enhancing reliability and customer satisfaction.
                  </p>
                </div>
              </div>
            </div>
            <div className="single-item">
              <div className="static-content">
                <span className="count-text">04</span>
                <div className="text">
                  <h3>Full Technical support</h3>
                  <p>
                    Comprehensive technical support available for all
                    bearing-related inquiries and requirements.
                  </p>
                </div>
              </div>
              <div className="overlay-content">
                <div className="icon-box">
                  <img
                    src="assets/img/technical-support.png"
                    style={{
                      paddingBottom: "5px",
                      width: "55px",
                      height: "55px",
                    }}
                    alt=""
                  />
                </div>
                <div className="text">
                  <h3>Full Technical support</h3>
                  <p>
                    Comprehensive technical support available for all
                    bearing-related inquiries and requirements.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="scroll-text">
            <ul className="text-list clearfix">
              <li>Why Choose SNKB Bearings </li>
              <li>Reliable Performance</li>
            </ul>
          </div>
        </div>
      </section>


      <section className="industry-section">
      <div className="industry-tab">
        <div className="tab-btns industry-tab-btns centred border-top border-bottom">
          <div className="auto-container">
            <div className="row clearfix">
              <div className="col-lg-3 col-md-6 col-sm-12 single-btn">
                <div
                  className={`p-tab-btn ${activeTab === '#tab-1' ? 'active-btn' : ''}`}
                  data-tab="#tab-1"
                  onClick={() => handleTabClick('#tab-1')}
                >
                  <div className="icon-box"><i className="flaticon-crane"></i></div>
                  <h4>Our mission</h4>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12 single-btn">
                <div
                  className={`p-tab-btn ${activeTab === '#tab-2' ? 'active-btn' : ''}`}
                  data-tab="#tab-2"
                  onClick={() => handleTabClick('#tab-2')}
                >
                  <div className="icon-box"><i className="flaticon-tanks"></i></div>
                  <h4>Our Vision</h4>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12 single-btn">
                <div
                  className={`p-tab-btn ${activeTab === '#tab-3' ? 'active-btn' : ''}`}
                  data-tab="#tab-3"
                  onClick={() => handleTabClick('#tab-3')}
                >
                  <div className="icon-box"><i className="flaticon-vaccine"></i></div>
                  <h4>Infrastructure</h4>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12 single-btn">
                <div
                  className={`p-tab-btn ${activeTab === '#tab-4' ? 'active-btn' : ''}`}
                  data-tab="#tab-4"
                  onClick={() => handleTabClick('#tab-4')}
                >
                  <div className="icon-box"><i className="flaticon-radiator"></i></div>
                  <h4>Core Values</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="auto-container">
      <div className="p-tabs-content">
        <div className={`p-tab ${activeTab === '#tab-1' ? 'active-tab' : ''}`} id="tab-1">
        {/* <div className={`p-tab ${activeTab === '#tab-1' ? 'active-tab' : ''}`} id="tab-1"> */}

          <div className="single-item-carousel ">
            <div className="content-inner">
              <div className="row clearfix">
                <div className="col-lg-6 col-md-12 col-sm-12 content-column">
                  <div className="content-box">
                    <div className="sec-title">
                      <span className="sub-title">Our mission</span>
                      <h2>Our mission</h2>
                    </div>
                    <div className="inner-box">
                      <ul className="list-style-one clearfix">
                        <li>Precision solutions exceeding industry standards</li>
                        <li>Long-term partnerships through exceptional service</li>
                      </ul>
                      <p>Our mission at SNKB Berings is to engineer precision solutions, drive innovation, and exceed customer expectations for seamless industrial operations</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 image-column">
                  <div className="image-box">
                    <figure className="image">
                      <img
                        src="/assets/img/mision.png"
                        style={{ width: '470px', height: '450px' }}
                        alt=""
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`p-tab ${activeTab === '#tab-2' ? 'active-tab' : ''}`} id="tab-2">
          <div className="single-item-carousel ">
            <div className="content-inner">
              <div className="row clearfix">
                <div className="col-lg-6 col-md-12 col-sm-12 content-column">
                  <div className="content-box">
                    <div className="sec-title">
                      <span className="sub-title">Our Vision</span>
                      <h2>Our Vision</h2>
                    </div>
                    <div className="inner-box">
                      <ul className="list-style-one clearfix">
                        <li>Innovation, Excellence, and Sustainable Growth</li>
                        <li>Leading Through Innovation and Global Impact</li>
                      </ul>
                      <p>Our vision at SNKB Berings is to pioneer innovative solutions, exceed industry standards, and become a global leader in precision engineering</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 image-column">
                  <div className="image-box">
                    <figure className="image">
                      <img
                        src="/assets/img/vision.png"
                        style={{ width: '470px', height: '450px' }}
                        alt=""
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`p-tab ${activeTab === '#tab-3' ? 'active-tab' : ''}`} id="tab-3">
          <div className="single-item-carousel ">
            <div className="content-inner">
              <div className="row clearfix">
                <div className="col-lg-6 col-md-12 col-sm-12 content-column">
                  <div className="content-box">
                    <div className="sec-title">
                      <span className="sub-title">Infrastructure</span>
                      <h2>Infrastructure</h2>
                    </div>
                    <div className="inner-box">
                      <ul className="list-style-one clearfix">
                        <li>Enhancing Efficiency and Reliability</li>
                        <li>Streamlining Operations</li>
                      </ul>
                      <p>Our infrastructure boasts state-of-the-art manufacturing facilities equipped with cutting-edge technology, ensuring precision engineering and consistent quality standards</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 image-column">
                  <div className="image-box">
                    <figure className="image">
                      <img
                        src="/assets/img/Infrastructure.png"
                        style={{ width: '470px', height: '450px' }}
                        alt=""
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`p-tab ${activeTab === '#tab-4' ? 'active-tab' : ''}`} id="tab-4">
          <div className="single-item-carousel">
            <div className="content-inner">
              <div className="row clearfix">
                <div className="col-lg-6 col-md-12 col-sm-12 content-column">
                  <div className="content-box">
                    <div className="sec-title">
                      <span className="sub-title">Core Values</span>
                      <h2>Core Values</h2>
                    </div>
                    <div className="inner-box">
                      <ul className="list-style-one clearfix">
                        <li>Adaptability, Collaboration, Excellence, Innovation</li>
                        <li>Integrity, Sustainability, Teamwork</li>
                      </ul>
                      <p>Our core values of Adaptability, Collaboration, Excellence, Innovation, Integrity, Sustainability, and Teamwork drive our every endeavor for success</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 image-column">
                  <div className="image-box">
                    <figure className="image">
                      <img
                        src="/assets/img/core-values.png"
                        style={{ width: '470px', height: '450px' }}
                        alt=""
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <style>
          {`
            .owl-nav.disabled {
              display: none;
            }
          `}
        </style>
      </div>
    </div>
      </div>
    </section>

      <section className="video-section">
        <div
          className="bg-layer"
          style={{ backgroundImage: "url(assets/img/video-bg.png)" }}
        />
        <div className="auto-container">
          <div className="sec-title light">
            <span className="sub-title">produce the best</span>
            <h2> SNKB Bearings</h2>
            <div className="curve-text">
              <div className="video-btn">
                <Link  className="lightbox-image" data-caption="">
                  <i className="flaticon-play-button" />
                </Link>
              </div>
              <span
                className="curved-circle-2"
                style={{
                  position: "absolute",
                  visibility: "visible",
                  height: "53.6262px",
                }}
              >
                <span
                  className="char1"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.333333em",
                    transform: "rotate(-74.3187deg)",
                    transformOrigin: "center 5em",
                  }}
                >
                  P
                </span>
                <span
                  className="char2"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.291667em",
                    transform: "rotate(-63.8019deg)",
                    transformOrigin: "center 5em",
                  }}
                >
                  l
                </span>
                <span
                  className="char3"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.375em",
                    transform: "rotate(-53.2851deg)",
                    transformOrigin: "center 5em",
                  }}
                >
                  a
                </span>
                <span
                  className="char4"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.333333em",
                    transform: "rotate(-42.0672deg)",
                    transformOrigin: "center 5em",
                  }}
                >
                  y
                </span>
                <span
                  className="char5"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.125em",
                    transform: "rotate(-34.3549deg)",
                    transformOrigin: "center 5em",
                  }}
                >
                  &nbsp;
                </span>
                <span
                  className="char6"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.333333em",
                    transform: "rotate(-26.6425deg)",
                    transformOrigin: "center 5em",
                  }}
                >
                  Y
                </span>
                <span
                  className="char7"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.375em",
                    transform: "rotate(-14.7235deg)",
                    transformOrigin: "center 5em",
                  }}
                >
                  o
                </span>
                <span
                  className="char8"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.375em",
                    transform: "rotate(-2.10336deg)",
                    transformOrigin: "center 5em",
                  }}
                >
                  u
                </span>
                <span
                  className="char9"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.375em",
                    transform: "rotate(10.5168deg)",
                    transformOrigin: "center 5em",
                  }}
                >
                  r
                </span>
                <span
                  className="char10"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.125em",
                    transform: "rotate(18.9302deg)",
                    transformOrigin: "center 5em",
                  }}
                >
                  &nbsp;
                </span>
                <span
                  className="char11"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.375em",
                    transform: "rotate(27.3437deg)",
                    transformOrigin: "center 5em",
                  }}
                >
                  V
                </span>
                <span
                  className="char12"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.291667em",
                    transform: "rotate(38.5616deg)",
                    transformOrigin: "center 5em",
                  }}
                >
                  i
                </span>
                <span
                  className="char13"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.375em",
                    transform: "rotate(49.7795deg)",
                    transformOrigin: "center 5em",
                  }}
                >
                  d
                </span>
                <span
                  className="char14"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.333333em",
                    transform: "rotate(61.6985deg)",
                    transformOrigin: "center 5em",
                  }}
                >
                  e
                </span>
                <span
                  className="char15"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.375em",
                    transform: "rotate(73.6175deg)",
                    transformOrigin: "center 5em",
                  }}
                >
                  o
                </span>
              </span>
              <span
                className="curved-circle-3"
                style={{
                  position: "absolute",
                  visibility: "visible",
                  height: "43.6624px",
                }}
              >
                <span
                  className="char1"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.333333em",
                    transform: "rotate(70.8558deg)",
                    transformOrigin: "center -3.16667em",
                  }}
                >
                  P
                </span>
                <span
                  className="char2"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.291667em",
                    transform: "rotate(60.829deg)",
                    transformOrigin: "center -3.16667em",
                  }}
                >
                  l
                </span>
                <span
                  className="char3"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.375em",
                    transform: "rotate(50.8023deg)",
                    transformOrigin: "center -3.16667em",
                  }}
                >
                  a
                </span>
                <span
                  className="char4"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.333333em",
                    transform: "rotate(40.107deg)",
                    transformOrigin: "center -3.16667em",
                  }}
                >
                  y
                </span>
                <span
                  className="char5"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.125em",
                    transform: "rotate(32.7541deg)",
                    transformOrigin: "center -3.16667em",
                  }}
                >
                  &nbsp;
                </span>
                <span
                  className="char6"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.333333em",
                    transform: "rotate(25.4011deg)",
                    transformOrigin: "center -3.16667em",
                  }}
                >
                  Y
                </span>
                <span
                  className="char7"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.375em",
                    transform: "rotate(14.0375deg)",
                    transformOrigin: "center -3.16667em",
                  }}
                >
                  o
                </span>
                <span
                  className="char8"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.375em",
                    transform: "rotate(2.00535deg)",
                    transformOrigin: "center -3.16667em",
                  }}
                >
                  u
                </span>
                <span
                  className="char9"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.375em",
                    transform: "rotate(-10.0268deg)",
                    transformOrigin: "center -3.16667em",
                  }}
                >
                  r
                </span>
                <span
                  className="char10"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.125em",
                    transform: "rotate(-18.0482deg)",
                    transformOrigin: "center -3.16667em",
                  }}
                >
                  &nbsp;
                </span>
                <span
                  className="char11"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.375em",
                    transform: "rotate(-26.0696deg)",
                    transformOrigin: "center -3.16667em",
                  }}
                >
                  V
                </span>
                <span
                  className="char12"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.291667em",
                    transform: "rotate(-36.7648deg)",
                    transformOrigin: "center -3.16667em",
                  }}
                >
                  i
                </span>
                <span
                  className="char13"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.375em",
                    transform: "rotate(-47.46deg)",
                    transformOrigin: "center -3.16667em",
                  }}
                >
                  d
                </span>
                <span
                  className="char14"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.333333em",
                    transform: "rotate(-58.8237deg)",
                    transformOrigin: "center -3.16667em",
                  }}
                >
                  e
                </span>
                <span
                  className="char15"
                  style={{
                    position: "absolute",
                    left: "50%",
                    marginLeft: "-0.375em",
                    transform: "rotate(-70.1873deg)",
                    transformOrigin: "center -3.16667em",
                  }}
                >
                  o
                </span>
              </span>
            </div>
          </div>
          <div className="lower-box">
            <div className="text" style={{ fontSize: 35 }}>
              <p>High Precision High Quality We Believe In Precision</p>
            </div>
            <div className="btn-box">
              <Link 
                to ="https://www.snkbbearing.com/About_Us"
                className="theme-btn btn-one"
              >
                <span>More Details</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="case-section">
        <div className="auto-container">
          <div className="sec-title">
            <span className="sub-title"> Industries We Serve</span>
            <h2>
              OUR COMPANY FOCUSES MAINLY <br /> ON END USER INDUSTRY
            </h2>
          </div>
        </div>
        <div className="outer-container border-top">
        <OwlCarousel
          className="case-carousel owl-carousel owl-theme"
          {...options}
        >
            <div className="case-block-one">
              <div className="inner-box">
                <div className="upper-content">
                  <h5>Construction &amp; Engineering</h5>
                </div>
                <div className="image-box">
                  <figure className="image">
                    <img src="assets/images/case/case-1.jpg" alt="" />
                  </figure>
                  <div className="view-btn">
                    <Link 
                      to ="assets/images/case/case-1.jpg"
                      className="lightbox-image"
                      data-fancybox="gallery"
                    >
                      <i className="flaticon-zoom-in" />
                    </Link>
                  </div>
                </div>
                <div className="lower-content centred">
                  <h3>
                    <Link >Pipeline System</Link>
                  </h3>
                </div>
              </div>
            </div>
            <div className="case-block-one">
              <div className="inner-box">
                <div className="upper-content">
                  <h5>Technology</h5>
                </div>
                <div className="image-box">
                  <figure className="image">
                    <img src="assets/images/case/case-2.jpg" alt=" " />
                  </figure>
                  <div className="view-btn">
                    <Link 
                      to ="assets/images/case/case-2.jpg"
                      className="lightbox-image"
                      data-fancybox="gallery"
                    >
                      <i className="flaticon-zoom-in" />
                    </Link>
                  </div>
                </div>
                <div className="lower-content centred">
                  <h3>
                    <Link >Sheet Metal Bending</Link>
                  </h3>
                </div>
              </div>
            </div>
            <div className="case-block-one">
              <div className="inner-box">
                <div className="upper-content">
                  <h5>Mechanical</h5>
                </div>
                <div className="image-box">
                  <figure className="image">
                    <img src="assets/images/case/case-3.jpg" alt="" />
                  </figure>
                  <div className="view-btn">
                    <Link 
                      to ="assets/images/case/case-3.jpg"
                      className="lightbox-image"
                      data-fancybox="gallery"
                    >
                      <i className="flaticon-zoom-in" />
                    </Link>
                  </div>
                </div>
                <div className="lower-content centred">
                  <h3>
                    <Link >Van Drilling Service</Link>
                  </h3>
                </div>
              </div>
            </div>
            <div className="case-block-one">
              <div className="inner-box">
                <div className="upper-content">
                  <h5>Material, Mechanical</h5>
                </div>
                <div className="image-box">
                  <figure className="image">
                    <img src="assets/images/case/case-4.jpg" alt="" />
                  </figure>
                  <div className="view-btn">
                    <Link 
                      to ="assets/images/case/case-4.jpg"
                      className="lightbox-image"
                      data-fancybox="gallery"
                    >
                      <i className="flaticon-zoom-in" />
                    </Link>
                  </div>
                </div>
                <div className="lower-content centred">
                  <h3>
                    <Link >Steel Springs</Link>
                  </h3>
                </div>
              </div>
            </div>
            <div className="case-block-one">
              <div className="inner-box">
                <div className="upper-content">
                  <h5>Construction Engineering</h5>
                </div>
                <div className="image-box">
                  <figure className="image">
                    <img src="assets/images/case/case-1.jpg" alt="" />
                  </figure>
                  <div className="view-btn">
                    <Link 
                      to ="assets/images/case/case-1.jpg"
                      className="lightbox-image"
                      data-fancybox="gallery"
                    >
                      <i className="flaticon-zoom-in" />
                    </Link>
                  </div>
                </div>
                <div className="lower-content centred">
                  <h3>
                    <Link >Pipeline System</Link>
                  </h3>
                </div>
              </div>
            </div>
            <div className="case-block-one">
              <div className="inner-box">
                <div className="upper-content">
                  <h5>Technology</h5>
                </div>
                <div className="image-box">
                  <figure className="image">
                    <img src="assets/images/case/case-2.jpg" alt="" />
                  </figure>
                  <div className="view-btn">
                    <Link 
                      to ="assets/images/case/case-2.jpg"
                      className="lightbox-image"
                      data-fancybox="gallery"
                    >
                      <i className="flaticon-zoom-in" />
                    </Link>
                  </div>
                </div>
                <div className="lower-content centred">
                  <h3>
                    <Link >Sheet Metal Bending</Link>
                  </h3>
                </div>
              </div>
            </div>
            <div className="case-block-one">
              <div className="inner-box">
                <div className="upper-content">
                  <h5>Mechanical</h5>
                </div>
                <div className="image-box">
                  <figure className="image">
                    <img src="assets/images/case/case-3.jpg" alt="" />
                  </figure>
                  <div className="view-btn">
                    <Link 
                      to ="assets/images/case/case-3.jpg"
                      className="lightbox-image"
                      data-fancybox="gallery"
                    >
                      <i className="flaticon-zoom-in" />
                    </Link>
                  </div>
                </div>
                <div className="lower-content centred">
                  <h3>
                    <Link >Van Drilling Service</Link>
                  </h3>
                </div>
              </div>
            </div>
            <div className="case-block-one">
              <div className="inner-box">
                <div className="upper-content">
                  <h5>Material, Mechanical</h5>
                </div>
                <div className="image-box">
                  <figure className="image">
                    <img src="assets/images/case/case-4.jpg" alt="" />
                  </figure>
                  <div className="view-btn">
                    <Link 
                      to ="assets/images/case/case-4.jpg"
                      className="lightbox-image"
                      data-fancybox="gallery"
                    >
                      <i className="flaticon-zoom-in" />
                    </Link>
                  </div>
                </div>
                <div className="lower-content centred">
                  <h3>
                    <Link >Steel Springs</Link>
                  </h3>
                </div>
              </div>
            </div>
            <div className="case-block-one">
              <div className="inner-box">
                <div className="upper-content">
                  <h5>Construction Engineering</h5>
                </div>
                <div className="image-box">
                  <figure className="image">
                    <img src="assets/images/case/case-1.jpg" alt="" />
                  </figure>
                  <div className="view-btn">
                    <Link 
                      to ="assets/images/case/case-1.jpg"
                      className="lightbox-image"
                      data-fancybox="gallery"
                    >
                      <i className="flaticon-zoom-in" />
                    </Link>
                  </div>
                </div>
                <div className="lower-content centred">
                  <h3>
                    <Link >Pipeline System</Link>
                  </h3>
                </div>
              </div>
            </div>
            <div className="case-block-one">
              <div className="inner-box">
                <div className="upper-content">
                  <h5>Technology</h5>
                </div>
                <div className="image-box">
                  <figure className="image">
                    <img src="assets/images/case/case-2.jpg" alt="" />
                  </figure>
                  <div className="view-btn">
                    <Link 
                      to ="assets/images/case/case-2.jpg"
                      className="lightbox-image"
                      data-fancybox="gallery"
                    >
                      <i className="flaticon-zoom-in" />
                    </Link>
                  </div>
                </div>
                <div className="lower-content centred">
                  <h3>
                    <Link >Sheet Metal Bending</Link>
                  </h3>
                </div>
              </div>
            </div>
            <div className="case-block-one">
              <div className="inner-box">
                <div className="upper-content">
                  <h5>Mechanical</h5>
                </div>
                <div className="image-box">
                  <figure className="image">
                    <img src="assets/images/case/case-3.jpg" alt="" />
                  </figure>
                  <div className="view-btn">
                    <Link 
                      to ="assets/images/case/case-3.jpg"
                      className="lightbox-image"
                      data-fancybox="gallery"
                    >
                      <i className="flaticon-zoom-in" />
                    </Link>
                  </div>
                </div>
                <div className="lower-content centred">
                  <h3>
                    <Link >Van Drilling Service</Link>
                  </h3>
                </div>
              </div>
            </div>
            <div className="case-block-one">
              <div className="inner-box">
                <div className="upper-content">
                  <h5>Material, Mechanical</h5>
                </div>
                <div className="image-box">
                  <figure className="image">
                    <img src="assets/images/case/case-4.jpg" alt="" />
                  </figure>
                  <div className="view-btn">
                    <Link 
                      to ="assets/images/case/case-4.jpg"
                      className="lightbox-image"
                      data-fancybox="gallery"
                    >
                      <i className="flaticon-zoom-in" />
                    </Link>
                  </div>
                </div>
                <div className="lower-content centred">
                  <h3>
                    <Link >Steel Springs</Link>
                  </h3>
                </div>
              </div>
            </div>

            </OwlCarousel>
      
        </div>
      </section>
    </>
  );
};

export default Home;
